<template>
  <ol v-if="content.children.length">
    <template v-for="(obj, index) of content.children">
      <li :class="obj.header[0].bold ? '' : 'term-box'">
        <template v-if="obj.header[0].bold">
          <div class="third-title">{{ parentIndexes[0] + 1 }}.{{ index + 1 }} {{ obj.header[0].content }}</div>
          <p
            v-for="main of obj.header.slice(1)"
            v-html="main.content"
          />
        </template>
        <template v-else>
          {{ parentIndexes[0] + 1 }}.{{ index + 1 }}<p class="term">{{ obj.header[0].content }}</p>
        </template>
      </li>
      <Depth4Sub
        :parentIndexes="[parentIndexes[0], index]"
        :content="obj"
        :key="index"
      />
    </template>
  </ol>
</template>
<script>
import Depth4Sub from './Depth4Sub.vue'

export default {
  props: {
    content: Object,
    parentIndexes: Array,
  },
  components: {
    Depth4Sub,
  },
}
</script>
<style lang="scss" scoped>
@import '../TermsOfUse.scss';
</style>
